try {
  //window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
} catch (e) {}

import toastr from 'toastr';
require('jquery-validation');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

(function($){

$(document).ready(function(){
  var loginForm = $('#login-form');
  if (loginForm) {
    loginForm.validate();

    $(document).on('click', '#login-form button[type="submit"]', function(e){
      e.preventDefault();
      let that = $(this);

      if (loginForm.valid()) {
        loginForm.submit();
        that.prop('disabled', true);
        that.find('span').removeClass('hidden');
      }

    });
  }

  var passwordReset = $('#password-reset');
  if (passwordReset) {
    passwordReset.validate();

    $(document).on('click', '#password-reset button', function(e){
      e.preventDefault();
      let that = $(this);

      $(passwordReset).find('.invalid-feedback').remove();

      if (passwordReset.valid()) {
        that.prop('disabled', true);
        that.find('span').removeClass('hidden');
        let data = $(passwordReset).serializeObject();

        axios.post('/password/email', data)
        .then(function (response) {
          $(passwordReset)[0].reset();
          toastr.success(response.data.message);
          window.segmentTriggered = window.segmentTriggered || false;
          const segmentEvent = new CustomEvent('segmentFirstInteraction', {});
          if (response.data.hasOwnProperty('segment_event')) {
            if (!window.segmentTriggered) {
              window.segmentTriggered = true;
              document.dispatchEvent(segmentEvent);
            }
            let segment_event = JSON.parse(response.data.segment_event);
            analytics.track(segment_event.event, segment_event.properties);
          }
        })
        .catch(function (error) {
          let errors = error.response;
          if (errors.hasOwnProperty('data')) {
            if (errors.data.hasOwnProperty('errors')) {
              if (typeof errors.data.errors === 'object') {
                for (const key in errors.data.errors) {
                  $(passwordReset).find('input[name="'+ key +'"]').closest('.form-group').append('<span style="display:block;" class="invalid-feedback" role="alert"><strong>' + errors.data.errors[key] + '</strong></span>');
                }
              } else {
                toastr.error(errors.data.errors);
              }
            }
          } else {
            toastr.error(window._global.errors.something_went_wrong);
          }

          if (error.response.data.errors.hasOwnProperty('segment_event')) {
            window.segmentTriggered = window.segmentTriggered || false;
            const segmentEvent = new CustomEvent('segmentFirstInteraction', {});
            if (!window.segmentTriggered) {
              window.segmentTriggered = true;
              document.dispatchEvent(segmentEvent);
            }
            let segment_event = JSON.parse(error.response.data.errors.segment_event);
            analytics.track(segment_event.event, segment_event.properties);
          }
        }).then(function(){
          that.find('span').addClass('hidden');
          that.prop('disabled', false);
        });
      }
    });
  }

  var passwordChange = $('#password-change');
  if (passwordChange) {
    passwordChange.validate();

    $(document).on('click', '#password-change button', function(e){
      e.preventDefault();
      let that = $(this);

      $(passwordChange).find('.invalid-feedback').remove();

      if (passwordChange.valid()) {
        that.prop('disabled', true);
        that.find('span').removeClass('hidden');
        let data = $(passwordChange).serializeObject();

        axios.post('/password/reset', data)
        .then(function (response) {
          $(passwordChange)[0].reset();
          toastr.success(response.data.message);
          window.location.href = '/';
        })
        .catch(function (error) {
          let errors = error.response;
          if (errors.hasOwnProperty('data')) {
            if (errors.data.hasOwnProperty('errors')) {
              if (typeof errors.data.errors === 'object') {
                for (const key in errors.data.errors) {
                  $(passwordChange).find('input[name="'+ key +'"]').closest('.form-group').append('<span style="display:block;" class="invalid-feedback" role="alert"><strong>' + errors.data.errors[key] + '</strong></span>');
                }
              } else {
                toastr.error(errors.data.errors);
              }
            }
          } else {
            toastr.error(window._global.errors.something_went_wrong);
          }
        }).then(function(){
          that.find('span').addClass('hidden');
          that.prop('disabled', false);
        });
      }
    });
  }

  $.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
      if (o[this.name]) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    return o;
  };

});

})(jQuery);